
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"Icon_Filter","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{attrs:{"id":"Masked_Area","fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"id":"Icon_Filter-2","clip-path":"url(#clip-path)","transform":"translate(2081 1782)"}},[_c('path',{staticClass:"cls-4",attrs:{"id":"noun_filter_2176283","d":"M.615 0a.617.617 0 00-.531.93l6.692 8.927v6.777a.616.616 0 00.892.551l2.464-1.232a.616.616 0 00.34-.551V9.856L17.163.929A.616.616 0 0016.632 0zm1.08 1.232h13.858L9.325 9.375a.61.61 0 00-.085.313v5.332l-1.232.616V9.688a.62.62 0 00-.085-.313z","transform":"translate(-2077.624 -1778.625)"}}),_c('path',{staticClass:"cls-4",attrs:{"id":"noun_filter_2176283_-_Outline","d":"M16.632-.1a.709.709 0 01.622.361.709.709 0 01-.005.719l-.006.009-6.671 8.9V15.4a.712.712 0 01-.4.64l-2.46 1.234a.715.715 0 01-1.036-.64V9.89L0 .98a.71.71 0 010-.72.709.709 0 01.615-.36zm.448.974A.516.516 0 0016.632.1H.615a.517.517 0 00-.447.774l6.708 8.949v6.81a.515.515 0 00.747.461l2.464-1.232a.513.513 0 00.285-.461V9.823zm-15.587.258h14.262l-6.347 8.3a.51.51 0 00-.068.257v5.395l-1.433.716V9.688a.52.52 0 00-.069-.258zm13.858.2H1.9l6.108 7.992a.721.721 0 01.1.364v5.787l1.032-.516V9.688a.71.71 0 01.1-.364l.007-.01z","transform":"translate(-2077.624 -1778.625)"}})])])
          )
        }
      }
    